import React from "react";
import { cn } from "utils";

export const Badge = ({ className, children }) => (
  <span
    className={cn(
      "inline-flex items-center px-2 py-0.5 rounded text-xs font-bold",
      className
    )}
  >
    {children}
  </span>
);

export const DMPBadge = () => (
  <Badge className="bg-violet-100 text-violet-800">DMP</Badge>
);

export const ExistingCustomerBadge = () => (
  <Badge className="bg-amber-100 text-amber-800">Existing Customer</Badge>
);
